import { render, staticRenderFns } from "./SupplierEvaluationSystem.vue?vue&type=template&id=bb42e122&scoped=true"
import script from "./SupplierEvaluationSystem.vue?vue&type=script&lang=js"
export * from "./SupplierEvaluationSystem.vue?vue&type=script&lang=js"
import style0 from "./SupplierEvaluationSystem.vue?vue&type=style&index=0&id=bb42e122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb42e122",
  null
  
)

export default component.exports